<div class="rti-cash-card">
  <div class="rti-cash-card-header">
    {{data.title}}
  </div>
  <div class="rti-cash-card-type">
  </div>
  <div class="rti-cash-card-make-model">
    {{data.label}}
  </div>
  <div class="rti-cash-card-image">
    <img [attr.src]="data.image.href" [ngStyle]="data.image.style"/>
  </div>
  <div class="rti-cash-card-pricing">
    <label><span>$</span>{{data.monthlypayment}}</label>
    <label class="term">{{data.term}}</label>
  </div>
  <div class="rti-cash-card-finance">
    <div class="rti-cash-card-finance-duration">
      <label>{{data.duration}}</label>
      <label class="term">{{data.durationTerm}}</label>
    </div>
    <div class="rti-cash-card-finance-down">
      <label><span>$</span>{{data.downpayment}}</label>
      <label class="term">{{data.downpaymentCondition}}</label>
    </div>
  </div>
</div>
